import { json } from "react-router-dom";
import { getHeaders } from "./common";

// api for fetching all form list from org id.
export const fetchAllForms = async (orgId) => {
  try {
    if (!orgId) return { success: false, error: "Organization ID is required" };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form/all/${orgId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to fetch forms.");
      return { success: false, error: "Failed to fetch forms" };
    }
  } catch (error) {
    console.error("Error fetching forms:", error);
    return { success: false, error: error.message };
  }
};

// api to create a form.
export const createForm = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/forms/create`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to create forms.");
      return { success: false, error: "Failed to create forms" };
    }
  } catch (error) {
    console.error("Error create forms:", error);
    return { success: false, error: error.message };
  }
};

// api to update a form.
export const updateForm = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/forms/update`,
      {
        method: "PUT",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to update forms.");
      return { success: false, error: "Failed to update forms" };
    }
  } catch (error) {
    console.error("Error update forms:", error);
    return { success: false, error: error.message };
  }
};

// api for fetching form details.
export const fetchFormDetails = async (formId) => {
  try {
    if (!formId) return { success: false, error: "Form ID is required" };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form/${formId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to fetch form details.");
      return { success: false, error: "Failed to fetch form details" };
    }
  } catch (error) {
    console.error("Error fetching form details :", error);
    return { success: false, error: error.message };
  }
};

export const fetchResultDetails = async (result_id) => {
    try {
        if (!result_id) return { success: false, error: "Result not found" };

        const response = await fetch(
            `${process.env.REACT_APP_API_ORIGIN}/portalform/form_response/${result_id}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch result details.");
            return { success: false, error: "Failed to fetch result details" };
        }
    } catch (error) {
        console.error("Error fetching result details :", error);
        return { success: false, error: error.message };
    }
};

// api for update form details.
export const updateFormDetails = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/forms/update`,
      {
        method: "PUT",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to update form details.");
      return { success: false, error: "Failed to update form details" };
    }
  } catch (error) {
    console.error("Error update form details :", error);
    return { success: false, error: error.message };
  }
};

// api for update form image.
export const updateFormImage = async (formId, file, is_finish) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const headers = Object.create(getHeaders());
    delete headers["Content-Type"];

    const response = await fetch(
        `${process.env.REACT_APP_API_ORIGIN}/portalform/forms/update_image?Id=${formId}&IsFinish=${is_finish}`,
      {
        method: "POST",
        headers: {
          ...headers,
          accept: "*/*",
        },
        credentials: "include",
        body: formData,
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to update form image.");
      return { success: false, error: "Failed to update form image." };
    }
  } catch (error) {
    console.error("Failed to update form image.", error);
    return { success: false, error: error.message };
  }
};

// api for fetch all fields of form.
export const fetchAllFormFields = async (formId) => {
  try {
    if (!formId) return { success: false, error: "Form ID is required" };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/all/${formId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to fetch form fields.");
      return { success: false, error: "Failed to fetch form fields" };
    }
  } catch (error) {
    console.error("Error fetching form fields", error);
    return { success: false, error: error.message };
  }
};

// api for create form field
export const createFormField = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/create`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to create form field.");
      return { success: false, error: "Failed to create form field" };
    }
  } catch (error) {
    console.error("Error create form field :", error);
    return { success: false, error: error.message };
  }
};

//API: create form field with sub questions in one request
export const createFormFieldWithSub = async (formData) => {
  try {

    const params = {
                "obj": formData
            };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/create_with_sub`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(formData),
      }
    );
    
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to create form field with sub questions.");
      return { success: false, error: "Failed to create form field with sub questions" };
    }
  } catch (error) {
    console.error("Error creating form field with sub questions:", error);
    return { success: false, error: error.message };
  }
};

// api for update form field
export const updateFormField = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/update`,
      {
        method: "PUT",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to update form field.");
      return { success: false, error: "Failed to update form field" };
    }
  } catch (error) {
    console.error("Error update form field :", error);
    return { success: false, error: error.message };
  }
};

// api for fetching a form field options.
export const fetchFormFieldsOptions = async (formFieldId) => {
  try {
    if (!formFieldId)
      return { success: false, error: "Form field id is required" };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/${formFieldId}`,
      {
        method: "GET",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to fetch form field options.");
      return { success: false, error: "Failed to fetch form field options" };
    }
  } catch (error) {
    console.error("Error fetching form field options", error);
    return { success: false, error: error.message };
  }
};

// api for update a form field question order.
export const updateFormFieldOrder = async (payload) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/update_order`,
      {
        method: "PUT",
        headers: getHeaders(),
        credentials: "include",
        body: JSON.stringify(payload),
      }
    );
    if (response.ok) {
      return { success: true };
    } else {
      console.error("Failed to update form field order.");
      return { success: false, error: "Failed to update form field order." };
    }
  } catch (error) {
    console.error("Error update form field order : ", error);
    return { success: false, error: error.message };
  }
};

// api for update form field options images.
export const updateFormFieldOptionImage = async (formFieldOptionsId, file, is_finish) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

      if (is_finish === undefined) {
          is_finish = false;
      }

    const headers = Object.create(getHeaders());
    delete headers["Content-Type"];

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_field_options/update_image?Id=${formFieldOptionsId}&IsFinish=${is_finish}`,
      {
        method: "POST",
        headers: {
          ...headers,
          accept: "*/*",
        },
        credentials: "include",
        body: formData,
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to update form field options image.");
      return {
        success: false,
        error: "Failed to update form field options image.",
      };
    }
  } catch (error) {
    console.error("Failed to update form field options image.", error);
    return { success: false, error: error.message };
  }
};

// api for remove form field options images.
export const RemoveFormFieldOptionImage = async (formFieldOptionsId, is_finish) => {
    try {
        if (is_finish === undefined) {
            is_finish = false;
        }

        const headers = Object.create(getHeaders());
        delete headers["Content-Type"];

        const response = await fetch(
            `${process.env.REACT_APP_API_ORIGIN}/portalform/form_field_options/remove_image?Id=${formFieldOptionsId}&IsFinish=${is_finish}`,
            {
                method: "DELETE",
                headers: {
                    ...headers,
                    accept: "*/*",
                },
                credentials: "include"
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to update form field options image.");
            return {
                success: false,
                error: "Failed to update form field options image.",
            };
        }
    } catch (error) {
        console.error("Failed to update form field options image.", error);
        return { success: false, error: error.message };
    }
};

// api for delete form form.
export const deleteForm = async (formId) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form/${formId}`,
      {
        method: "DELETE",
        headers: getHeaders(),
        credentials: "include",
      }
    );
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to delete form.");
      return { success: false, error: "Failed to delete form." };
    }
  } catch (error) {
    console.error("Failed to delete form. :", error);
    return { success: false, error: error.message };
  }
};

// api for delete form field.=
export const deleteFormField = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/${id}`,
      {
        method: "DELETE",
        headers: getHeaders(),
        credentials: "include",
      }
    );
    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to delete question.");
      return { success: false, error: "Failed to delete question." };
    }
  } catch (error) {
    console.error("Failed to delete question. :", error);
    return { success: false, error: error.message };
  }
};

// api for duplicate/copy a form
export const duplicateForm = async (formId, form_as_template) => {
  try {
    if (!formId) return { success: false, error: "Form ID is required" };



    const response = await fetch(
        `${process.env.REACT_APP_API_ORIGIN}/portalform/forms/copy?Id=${formId}&form_as_template=${form_as_template}`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to duplicate form.");
      return { success: false, error: "Failed to duplicate form" };
    }
  } catch (error) {
    console.error("Error duplicating form:", error);
    return { success: false, error: error.message };
  }
};

// api for duplicate/copy a form field (question)
export const duplicateFormField = async (formFieldId) => {
  try {
    if (!formFieldId) return { success: false, error: "Form field ID is required" };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_fields/copy?Id=${formFieldId}`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to duplicate form field.");
      return { success: false, error: "Failed to duplicate form field" };
    }
  } catch (error) {
    console.error("Error duplicating form field:", error);
    return { success: false, error: error.message };
  }
};

// api for duplicate/copy a form field option
export const duplicateFormFieldOption = async (formFieldOptionId) => {
  try {
    if (!formFieldOptionId) return { success: false, error: "Form field option ID is required" };

    const response = await fetch(
      `${process.env.REACT_APP_API_ORIGIN}/portalform/form_field_options/copy?Id=${formFieldOptionId}`,
      {
        method: "POST",
        headers: getHeaders(),
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data };
    } else {
      console.error("Failed to duplicate form field option.");
      return { success: false, error: "Failed to duplicate form field option" };
    }
  } catch (error) {
    console.error("Error duplicating form field option:", error);
    return { success: false, error: error.message };
  }
};
// api for fetching all form list from org id.
export const getcustom_paramter_data = async (paramname) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_ORIGIN}/portalform/form_field_options/custom_paramter_data?param_name=${paramname}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch data.");
            return { success: false, error: "Failed to fetch data" };
        }
    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, error: error.message };
    }
};